import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { assertNotNil } from '../../../../utils/types';
import UserOverview from './UserOverview';
import { useAnalytics } from '../../../../utils/analytics/useAnalytics';
import { pageViewed } from '../../../../utils/analytics/events/page/events';

const UserOverviewContainer = () => {
  const urlParams = useParams();
  const { userId } = urlParams;
  assertNotNil(userId);

  const { track } = useAnalytics();
  useEffect(() => {
    track(
      pageViewed({
        category: 'settings',
        name: 'view user',
        id: userId,
      }),
    );
  }, [track, userId]);

  return <UserOverview userId={userId} />;
};

export default UserOverviewContainer;
